import { render, staticRenderFns } from "./scroll-button.vue?vue&type=template&id=dc661816"
import script from "./scroll-button.vue?vue&type=script&lang=js"
export * from "./scroll-button.vue?vue&type=script&lang=js"
import style0 from "./scroll-button.vue?vue&type=style&index=0&id=dc661816&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports